import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setIsCheckListener } from '../../stories/actions';

import Label from '../Labels/Label';

const ButtonSwitche = ({ paragraph, setIsCheckListenerAction }) => {
    const [checked, setChecked] = useState(false);

    const handlerChangeChecked = (e) => {
        const check = e.target.checked;

        setIsCheckListenerAction(check);

        setChecked(check);
    };

    return (
        <div className="col-md-12 mb-2">
            <div className='button_server_container' title='Desligar o portal'>
                <Label text={paragraph} />

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={checked}
                        onChange={handlerChangeChecked}
                        className='input_server_connect'
                    />
                    <span className="slider round"></span>
                </label>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state
    };
};

const mapStateActionToProps = (dispatch) => {
    return {
        setIsCheckListenerAction: (isCheckListener) => dispatch(setIsCheckListener(isCheckListener))
    };
};

export default connect(mapStateToProps, mapStateActionToProps)(ButtonSwitche);